module.exports = __webpack_public_path__ + "static/media/7.60a5c3e5.jpg";